


































































import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class PfRegister extends Vue {
  private form: any = {
    registerName: null,
    registerPwd: null,
    confirmPwd: null,
    verifyCode: null,
    isVerifyCode: 1,
  };
  private checked = false;
  private timeCount = 0;
  private timer: any = null;
  private isShowCount = false;

  private async getVerifyCode() {
    if (this.form.registerName) {
      await this.$apis.getVerifyCode({
        phone: this.form.registerName,
        verifyCode: "0000",
        type: "1",
      });
      this.handleCount(60);
    } else {
      this.$message.warning("手机号码不能为空");
    }
  }
  private async register() {
    if (this.form.registerName && this.form.verifyCode) {
      // if (this.form.registerPwd !== this.form.confirmPwd) {
      //   this.$message.warning("密码与确认密码不一致");
      //   return;
      // }
      if (!this.checked) {
        this.$message.warning("请选择《服务协议》和《隐私政策》");
        return;
      }
      try {
        this.form.agentCode =
          sessionStorage.getItem("LONGYIXIU_agentCode") || null;
        await this.$store.dispatch("user/register", this.form);
        const str: any = this.$route.query.redirect;
        if (str) {
          this.$router.replace(str);
        } else {
          this.$router.replace("/activeManagement.html");
        }
        // this.$router.push("/voting/list");
        this.$message.success("注册成功");
      } catch (error) {
        console.log(error);
      }
    } else {
      this.$message.warning("手机号, 验证码都不能为空");
    }
  }
  private handleCount(count: number) {
    if (!this.timer) {
      this.timeCount = count;
      this.isShowCount = true;
      this.timer = setInterval(() => {
        if (this.timeCount > 0 && this.timeCount <= count) {
          this.timeCount--;
        } else {
          this.isShowCount = false;
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    }
  }
  private handleToEmit(componentName: any) {
    this.$emit("goto", componentName);
  }

  // beforeDestroy
  private beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  }
  private created() {
    document.title = "注册_" + this.$globalName;
  }
}
